import { createAsyncThunk } from '@reduxjs/toolkit'
import { buildQuery } from '../../utils/buildQuery'
import { callApi } from '../../utils/callApi'
import { IDtoSearch } from '../statSales/types'
import { IStatTechSupportState } from './types'

export const getStat = createAsyncThunk<IStatTechSupportState['data'], IDtoSearch>(
  'techSupport/getStat',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/stat?${query}` : '/admin-tech-support/stat',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const searchStat = createAsyncThunk<IStatTechSupportState['data'], IDtoSearch>(
  'techSupport/searchStat',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/stat?${query}` : '/admin-tech-support/stat',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const downlaodStat = createAsyncThunk<{ data: Buffer }, IDtoSearch>(
  'techSupport/downlaodStat',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/stat/download?${query}` : '/admin-tech-support/stat/download',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const getStatBlock2 = createAsyncThunk<IStatTechSupportState['dataRating'], IDtoSearch>(
  'techSupport/getStatBlock2',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/stat/block2?${query}` : '/admin-tech-support/stat/block2',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const searchStatBlock2 = createAsyncThunk<IStatTechSupportState['dataRating'], IDtoSearch>(
  'techSupport/searchStatBlock2',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/stat/block2?${query}` : '/admin-tech-support/stat/block2',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const downlaodStatBlock2 = createAsyncThunk<{ data: Buffer }, IDtoSearch>(
  'techSupport/downlaodStatBlock2',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/stat/block2/download?${query}` : '/admin-tech-support/stat/block2/download',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const downlaodStatBlock3 = createAsyncThunk<{ data: Buffer }, IDtoSearch>(
  'techSupport/downlaodStatBlock3',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/stat/block3/download?${query}` : '/admin-tech-support/stat/block3/download',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)
